import { render, staticRenderFns } from "./OptionHealthInstructionsYN.vue?vue&type=template&id=2e13bfb4"
import script from "./OptionHealthInstructionsYN.vue?vue&type=script&lang=js"
export * from "./OptionHealthInstructionsYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports